(function () {
  'use strict';

  const STOREFRONT_TOKEN = ((window.LIVE && window.LIVE.storefrontToken) || 'ed761c0d0f68bc596e5e4dd4e29e6407');
  const SHOP_DOMAIN = ((window.LIVE && window.LIVE.shopDomain) || 'live-ecom.myshopify.com');
  const API_VERSION = '2025-07';
  const COLOR_BASE_URL = 'https://imagens.liveoficial.com.br/color-sku/';
  const IMAGE_WIDTH = 120;
  const IMAGE_HEIGHT = 180;
  const MAX_LOOK_REFS = 50;
  const FOCUSABLE = 'a[href]:not([tabindex="-1"]), button:not([disabled]):not([tabindex="-1"]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function createInstance() {
    const dataEl = document.getElementById('ShopThisLookData');
    const sidebar = document.getElementById('ShopThisLookSidebar');
    const overlay = document.getElementById('ShopThisLookOverlay');
    if (!dataEl || !sidebar) return null;

    let DATA;
    try {
      DATA = JSON.parse(dataEl.textContent);
    } catch (e) {
      return null;
    }
    if (!DATA || !DATA.product || !DATA.variants) return null;

    const body = sidebar.querySelector('.shop-this-look-sidebar__body');
    if (!body) return null;

    const controller = new AbortController();
    const signal = controller.signal;
    const observers = [];
    const timers = new Set();

    function later(fn, ms) {
      const id = setTimeout(function () {
        timers.delete(id);
        fn();
      }, ms);
      timers.add(id);
      return id;
    }

    function getFooter() { return document.getElementById('ShopThisLookFooter'); }
    function getFooterError() { return document.getElementById('ShopThisLookFooterError'); }
    function getAddAllBtn() { return document.getElementById('ShopThisLookAddAll'); }
    function getCloseBtn() { return document.getElementById('CloseShopThisLook'); }

    const optionNames = DATA.optionNames || [];
    let colorIndex = -1;
    optionNames.forEach(function (name, i) {
      if (colorIndex === -1 && /color/i.test(String(name))) colorIndex = i;
    });

    let gqlPdp = null;
    let gqlPdpPromise = null;
    let renderToken = 0;
    let adding = false;
    let lastFocused = null;
    let visibilityTimer = null;

    const productCache = new Map();

    function escapeHtml(str) {
      return String(str == null ? '' : str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }

    function routeRoot() {
      return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    }

    function formatMoney(cents) {
      let out = null;
      try {
        if (window.Shopify && typeof Shopify.formatMoney === 'function') {
          const fmt = (typeof moneyFormat !== 'undefined' && moneyFormat) || '${{amount}}';
          out = Shopify.formatMoney(cents, fmt);
        }
      } catch (e) { /* noop */ }
      if (out == null) out = '$' + (Number(cents || 0) / 100).toFixed(2);
      return String(out).replace(/\.00(?!\d)/, '');
    }

    function isActive(raw) {
      if (raw === null || raw === undefined || raw === '') return true;
      const n = String(raw).trim().toLowerCase();
      return n !== 'false' && n !== '0';
    }

    function isProgressive(raw) {
      return String(raw == null ? '' : raw).trim().toLowerCase() === 'true';
    }

    let colorNameMap = null;
    // Same map the PDP colour title reads, so codes turn into the names shown there.
    function colorName(code) {
      if (colorNameMap === null) {
        const source = document.querySelector('[data-colors-list]');
        try {
          colorNameMap = source ? JSON.parse(source.textContent) : {};
        } catch (e) {
          colorNameMap = {};
        }
      }
      const value = String(code == null ? '' : code);
      const name = colorNameMap[value.toUpperCase()];
      return name && String(name).trim() ? String(name).trim() : value;
    }

    function sameColor(value, target) {
      if (!target || !target.code) return false;
      const code = String(value == null ? '' : value).trim().toLowerCase();
      if (!code) return false;
      if (code === target.code) return true;
      return !!target.name && colorName(value).trim().toLowerCase() === target.name;
    }

    function el(html) {
      const tpl = document.createElement('template');
      tpl.innerHTML = html.trim();
      return tpl.content.firstElementChild;
    }

    // ---- PDP variant data (Liquid map merged with Storefront GraphQL) ---- //

    function lookupVariant(id) {
      const key = String(id);
      const gql = gqlPdp && gqlPdp.byId[key];
      const liquid = DATA.variants[key];
      if (!gql && !liquid) return null;
      const merged = Object.assign({}, liquid || {}, gql || {});
      if (gql && gql.look == null && liquid) merged.look = liquid.look;
      return merged;
    }

    function lookFor(info) {
      if (!info || !Array.isArray(info.look)) return [];
      const seen = {};
      const entries = [];
      info.look.forEach(function (entry) {
        if (!entry) return;
        const id = String(entry.id == null ? '' : entry.id).trim();
        const handle = String(entry.handle == null ? '' : entry.handle).trim();
        if (!id || !handle || seen[id]) return;
        seen[id] = true;
        entries.push({ id: id, handle: handle });
      });
      return entries;
    }

    function currentColorCode() {
      const logic = document.querySelector('.product-variants .selector-wrapper.color .selector-options div.Active');
      if (logic && logic.dataset.val) return String(logic.dataset.val);
      const visual = document.querySelector('.option-color.active');
      if (visual && (visual.dataset.val || visual.dataset.color)) return String(visual.dataset.val || visual.dataset.color);
      return '';
    }

    function currentSizeValue() {
      const active = document.querySelector('.product-variants .selector-wrapper.size .selector-options div.Active');
      return active && active.dataset.val ? String(active.dataset.val) : '';
    }

    function variantColor(info) {
      if (colorIndex === -1 || !info || !Array.isArray(info.options)) return '';
      return String(info.options[colorIndex] || '');
    }

    function findByColor(color) {
      const target = color.trim().toLowerCase();
      if (!target) return null;
      const ids = gqlPdp ? Object.keys(gqlPdp.byId) : Object.keys(DATA.variants);
      const matches = [];
      ids.forEach(function (id) {
        const info = lookupVariant(id);
        if (info && variantColor(info).trim().toLowerCase() === target) matches.push({ id: id, info: info });
      });
      if (!matches.length) return null;
      return matches.find(function (m) { return isActive(m.info.active) && m.info.available; }) ||
        matches.find(function (m) { return isActive(m.info.active); }) ||
        matches[0];
    }

    function resolveCurrentSync() {
      const vid = window.__lvResolvedVariantId != null ? String(window.__lvResolvedVariantId) : '';
      if (vid) {
        const info = lookupVariant(vid);
        if (info) return { id: vid, info: info };
      }
      const byColor = findByColor(currentColorCode());
      if (byColor) return byColor;
      if (window.firstVariant && window.firstVariant.id) {
        const first = lookupVariant(window.firstVariant.id);
        if (first) return { id: String(window.firstVariant.id), info: first };
      }
      const anyId = Object.keys(DATA.variants)[0];
      return anyId ? { id: anyId, info: lookupVariant(anyId) } : null;
    }

    async function resolveCurrentForOpen() {
      const vid = window.__lvResolvedVariantId != null ? String(window.__lvResolvedVariantId) : '';
      if (vid && !lookupVariant(vid)) {
        try { await ensurePdpGql(); } catch (e) { /* noop */ }
      }
      return resolveCurrentSync();
    }

    // ---- Storefront GraphQL ---- //

    function variantIdFromGid(gid) {
      return String(gid == null ? '' : gid).trim().split('/').pop();
    }

    // null means "no metafield on this variant" so the Liquid map can still supply the look.
    function lookFromReferences(metafield) {
      if (!metafield || !metafield.references) return null;
      const entries = [];
      (metafield.references.nodes || []).forEach(function (node) {
        if (!node || !node.product || !node.product.handle) return;
        entries.push({ id: variantIdFromGid(node.id), handle: node.product.handle });
      });
      return entries;
    }

    function fetchProductGql(handle) {
      if (productCache.has(handle)) return productCache.get(handle);

      const promise = (async function () {
        const query = `
          query ($handle: String!, $cursor: String) {
            product(handle: $handle) {
              title
              handle
              featuredImage { url(transform: { maxWidth: 400, maxHeight: 400 }) }
              options { name }
              variants(first: 250, after: $cursor) {
                edges {
                  cursor
                  node {
                    id
                    title
                    availableForSale
                    selectedOptions { name value }
                    price { amount }
                    compareAtPrice { amount }
                    image { url(transform: { maxWidth: 400, maxHeight: 400 }) }
                    active: metafield(namespace: "custom", key: "active") { value }
                    progressiveSale: metafield(namespace: "custom", key: "progressive_sale") { value }
                    shopTheLook: metafield(namespace: "custom", key: "shop_the_look") {
                      references(first: ${MAX_LOOK_REFS}) {
                        nodes {
                          ... on ProductVariant {
                            id
                            product { handle }
                          }
                        }
                      }
                    }
                  }
                }
                pageInfo { hasNextPage }
              }
            }
          }
        `;

        const variants = [];
        let info = null;
        let cursor = null;
        let hasNext = true;

        while (hasNext) {
          const res = await fetch('https://' + SHOP_DOMAIN + '/api/' + API_VERSION + '/graphql.json', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN
            },
            body: JSON.stringify({ query: query, variables: { handle: handle, cursor: cursor } })
          });
          const json = await res.json();
          const product = json && json.data && json.data.product;
          if (!product) throw new Error('Product not found: ' + handle);

          if (!info) {
            info = {
              title: product.title,
              handle: product.handle,
              image: product.featuredImage ? product.featuredImage.url : null,
              optionNames: (product.options || []).map(function (o) { return o.name; })
            };
          }

          const edges = (product.variants && product.variants.edges) || [];
          edges.forEach(function (edge) {
            const n = edge.node;
            cursor = edge.cursor;
            variants.push({
              id: variantIdFromGid(n.id),
              title: n.title || '',
              available: !!n.availableForSale,
              active: n.active ? n.active.value : null,
              progressive: n.progressiveSale ? n.progressiveSale.value : null,
              options: (n.selectedOptions || []).map(function (o) { return o.value; }),
              price: n.price ? Math.round(parseFloat(n.price.amount) * 100) : 0,
              compare: n.compareAtPrice ? Math.round(parseFloat(n.compareAtPrice.amount) * 100) : 0,
              image: n.image ? n.image.url : null,
              look: lookFromReferences(n.shopTheLook)
            });
          });
          hasNext = !!(product.variants && product.variants.pageInfo && product.variants.pageInfo.hasNextPage);
        }

        const byId = {};
        variants.forEach(function (v) { byId[v.id] = v; });
        return { product: info, variants: variants, byId: byId };
      })();

      productCache.set(handle, promise);
      promise.catch(function () { productCache.delete(handle); });
      return promise;
    }

    function ensurePdpGql() {
      if (!gqlPdpPromise) {
        gqlPdpPromise = fetchProductGql(DATA.product.handle).then(function (data) {
          gqlPdp = data;
          return data;
        });
        gqlPdpPromise.catch(function () { gqlPdpPromise = null; });
      }
      return gqlPdpPromise;
    }

    // ---- Referenced variant resolution ---- //

    function findOptionIndex(names, re) {
      for (let i = 0; i < (names || []).length; i++) {
        if (re.test(String(names[i]))) return i;
      }
      return -1;
    }

    function optionValue(variant, idx) {
      return idx === -1 ? '' : String((variant.options || [])[idx] || '');
    }

    // Like the PDP, the colour selected there wins whenever the product offers it; otherwise the
    // card opens on the referenced variant, falling back to another size of its colour when that
    // exact one is gone and giving up when the whole colour is hidden. Within the colour, the size
    // selected on the PDP is preferred over the one the metafield points at.
    function lookInitial(data, variantId, pdpColor, pdpSize) {
      const referenced = data.byId[String(variantId)];
      if (!referenced) return null;

      const colorIdx = findOptionIndex(data.product.optionNames, /color/i);
      const sizeIdx = findOptionIndex(data.product.optionNames, /size/i);
      const shown = data.variants.filter(function (v) { return isActive(v.active); });
      const wantedSizes = [pdpSize, optionValue(referenced, sizeIdx)]
        .map(function (s) { return String(s == null ? '' : s).trim().toUpperCase(); })
        .filter(Boolean);

      const bestOf = function (list) {
        const buyable = list.filter(function (v) { return v.available; });
        if (sizeIdx !== -1) {
          for (let i = 0; i < wantedSizes.length; i++) {
            const match = buyable.find(function (v) {
              return optionValue(v, sizeIdx).trim().toUpperCase() === wantedSizes[i];
            });
            if (match) return match;
          }
        }
        return buyable[0] || null;
      };

      if (colorIdx !== -1) {
        const matched = bestOf(shown.filter(function (v) { return sameColor(optionValue(v, colorIdx), pdpColor); }));
        if (matched) return matched;
      }

      const siblings = colorIdx === -1 ? shown : shown.filter(function (v) {
        return optionValue(v, colorIdx) === optionValue(referenced, colorIdx);
      });
      return bestOf(siblings) || (isActive(referenced.active) ? referenced : siblings[0] || null);
    }

    function lookCardConfig(data, variantId, pdpColor, pdpSize) {
      const initial = lookInitial(data, variantId, pdpColor, pdpSize);
      if (!initial) return null;
      return {
        title: data.product.title,
        urlBase: routeRoot() + 'products/' + data.product.handle,
        productImage: data.product.image,
        optionNames: data.product.optionNames || [],
        variants: data.variants,
        initialId: String(initial.id)
      };
    }

    function pdpCardConfig(resolved) {
      const source = gqlPdp;
      const variants = source
        ? source.variants
        : Object.keys(DATA.variants).map(function (id) { return Object.assign({ id: id }, DATA.variants[id]); });
      return {
        title: DATA.product.title,
        urlBase: DATA.product.url,
        productImage: DATA.product.image || (source && source.product.image) || null,
        optionNames: source ? source.product.optionNames : optionNames,
        variants: variants,
        initialId: String(resolved.id)
      };
    }

    // ---- Card rendering ---- //

    function priceHtml(v) {
      let html = '<span class="look-card__price-current money">' + escapeHtml(formatMoney(v.price)) + '</span>';
      if (v.compare > v.price) {
        html += '<span class="look-card__price-compare money">' + escapeHtml(formatMoney(v.compare)) + '</span>';
      }
      return html;
    }

    const badges = DATA.badges || {};
    const saleRank = badges.saleOrder === 'first' ? -2 : (badges.saleOrder === 'default' ? 0 : 2);

    // PDP swatch order by the badge actually shown: none first, then "buy & save"; Sale and New colours move per theme settings.
    function badgeRank(color) {
      const rank = (color.progressive && badges.progressive) ? 1 : (color.sale ? saleRank : 0);
      return color.isNew ? window.ColorBadgeNew.rank(rank, saleRank) : rank;
    }

    // Same swatch list the PDP builds: every variant is walked because they are ordered
    // size-then-colour, so collecting only the buyable ones would reorder the colours by
    // which size happens to be in stock. Colours without an active, in-stock variant are
    // dropped as on the PDP, except the one the card opens on.
    function colorOptions(variants, colorIdx, initial) {
      const byColor = new Map();
      variants.forEach(function (v) {
        const value = optionValue(v, colorIdx);
        if (!value) return;
        const key = value.toLowerCase();
        let meta = byColor.get(key);
        if (!meta) {
          meta = { value: value, sale: false, progressive: false, isNew: !!window.ColorBadgeNew && window.ColorBadgeNew.matches(value), shown: false };
          byColor.set(key, meta);
        }
        if (isActive(v.active) && v.available) meta.shown = true;
        if (v.compare > v.price) meta.sale = true;
        if (isProgressive(v.progressive)) meta.progressive = true;
      });

      const initialKey = optionValue(initial, colorIdx).toLowerCase();
      const colors = [];
      byColor.forEach(function (meta, key) {
        if (meta.shown || key === initialKey) colors.push(meta);
      });
      return colors.sort(function (a, b) { return badgeRank(a) - badgeRank(b); });
    }

    function otherBadgeHtml(color) {
      if (color.progressive && badges.progressive) {
        // Liquid's `t` filter already HTML-escaped the label, so it is inserted as it arrives.
        return '<span class="look-card__badge look-card__badge--progressive">' +
          (badges.progressiveText || '') + '</span>';
      }
      if (color.sale && badges.sale !== false) {
        return '<span class="look-card__badge look-card__badge--sale">' + escapeHtml(badges.saleText || 'sale') + '</span>';
      }
      return '';
    }

    function badgeHtml(color) {
      const html = otherBadgeHtml(color);
      if (!color.isNew) return html;
      return window.ColorBadgeNew.badgeHtml(html, {
        badge: 'look-card__badge look-card__badge--new',
        stacked: 'look-card__badge--stacked'
      });
    }

    function swatchAriaLabel(color, name) {
      const newLabel = color.isNew ? window.ColorBadgeNew.label(otherBadgeHtml(color)) : '';
      return 'Color: ' + name + (newLabel ? ', ' + newLabel : '');
    }

    function optionsGroupHtml(kind, label, itemsHtml) {
      return '<div class="look-card__options look-card__options--' + kind + '" role="group" aria-label="' + escapeHtml(label) + '">' +
        '<span class="look-card__options-label">' + escapeHtml(label) + ': <span class="look-card__options-value"></span></span>' +
        '<div class="look-card__slider swiper"><div class="look-card__track swiper-wrapper">' + itemsHtml + '</div></div>' +
      '</div>';
    }

    function buildCardEl(cfg) {
      const colorIdx = findOptionIndex(cfg.optionNames, /color/i);
      const sizeIdx = findOptionIndex(cfg.optionNames, /size/i);
      const variants = cfg.variants || [];
      const activeVariants = variants.filter(function (v) { return isActive(v.active); });
      const pool = activeVariants.length ? activeVariants : variants;
      const selectable = pool.filter(function (v) { return v.available; });

      const initial = variants.find(function (v) { return String(v.id) === String(cfg.initialId); }) || selectable[0] || pool[0];
      if (!initial) return null;

      const colors = colorIdx === -1 ? [] : colorOptions(variants, colorIdx, initial);

      const sizes = [];
      if (sizeIdx !== -1) {
        const seenSize = {};
        variants.forEach(function (v) {
          const s = optionValue(v, sizeIdx);
          if (s && !seenSize[s]) {
            seenSize[s] = true;
            sizes.push(s);
          }
        });
      }

      let colorsHtml = '';
      if (colors.length) {
        colorsHtml = optionsGroupHtml('color', 'Color', colors.map(function (c) {
          const label = colorName(c.value);
          return '<div class="look-card__swatch swiper-slide" role="button" tabindex="0"' +
            ' data-val="' + escapeHtml(c.value.toLowerCase()) + '"' +
            ' data-color-label="' + escapeHtml(label) + '"' +
            ' aria-label="' + escapeHtml(swatchAriaLabel(c, label)) + '"' +
            ' aria-pressed="false"' +
            ' style="background-image: url(' + escapeHtml(COLOR_BASE_URL + encodeURIComponent(c.value) + '.png') + ')">' +
            badgeHtml(c) +
          '</div>';
        }).join(''));
      }

      let sizesHtml = '';
      if (sizes.length) {
        sizesHtml = optionsGroupHtml('size', 'Size', sizes.map(function (s) {
          return '<div class="look-card__size swiper-slide" role="button" tabindex="0" data-val="' + escapeHtml(s) + '" aria-pressed="false">' +
            escapeHtml(s) +
          '</div>';
        }).join(''));
      }

      const root = el('<div class="look-card">' +
        '<a class="look-card__media" href="' + escapeHtml(cfg.urlBase) + '" tabindex="-1" aria-hidden="true">' +
          '<img class="look-card__image" alt="' + escapeHtml(cfg.title) + '" aria-hidden="true" width="' + IMAGE_WIDTH + '" height="' + IMAGE_HEIGHT + '" loading="lazy">' +
        '</a>' +
        '<div class="look-card__info">' +
          '<div class="look-card__head">' +
            '<a class="look-card__title-link" href="' + escapeHtml(cfg.urlBase) + '">' +
              '<span class="look-card__title">' + escapeHtml(cfg.title) + '</span>' +
            '</a>' +
            '<span class="look-card__price"></span>' +
          '</div>' +
          colorsHtml + sizesHtml +
          '<button type="button" class="look-card__submit">Add</button>' +
          '<div class="look-card__error" role="alert" hidden></div>' +
        '</div>' +
      '</div>');

      bindCard(root, cfg, { colorIdx: colorIdx, sizeIdx: sizeIdx, pool: pool, initial: initial });
      return root;
    }

    function destroySliders(root) {
      root.querySelectorAll('.look-card__slider').forEach(function (node) {
        if (!node.swiper) return;
        try { node.swiper.destroy(true, false); } catch (e) { /* noop */ }
      });
    }

    // A selected colour or size can sit past the visible part of its row, so bring it into view.
    function revealSelected(root) {
      root.querySelectorAll('.look-card__slider').forEach(function (node) {
        const swiper = node.swiper;
        if (!swiper || !swiper.slides || !swiper.slides.length) return;
        const index = Array.prototype.findIndex.call(swiper.slides, function (slide) {
          return slide.classList.contains('_selected');
        });
        if (index < 1) return;
        const view = node.getBoundingClientRect();
        const box = swiper.slides[index].getBoundingClientRect();
        if (box.left >= view.left && box.right <= view.right) return;
        try { swiper.slideTo(index, 0); } catch (e) { /* noop */ }
      });
    }

    function initSliders(root) {
      if (!window.Swiper) return;
      root.querySelectorAll('.look-card__slider').forEach(function (node) {
        if (node.classList.contains('swiper-initialized')) return;
        try {
          new window.Swiper(node, {
            slidesPerView: 'auto',
            spaceBetween: 8,
            freeMode: true,
            watchOverflow: true,
            // Slides carry their own labels — Swiper's a11y would relabel them "1 / 3".
            a11y: { enabled: false },
            mousewheel: { enabled: true, forceToAxis: true, releaseOnEdges: true }
          });
        } catch (e) { /* noop */ }
      });
      revealSelected(root);
    }

    function bindCard(root, cfg, ctx) {
      const state = {
        color: ctx.colorIdx !== -1 ? optionValue(ctx.initial, ctx.colorIdx).toLowerCase() : '',
        size: ctx.sizeIdx !== -1 ? optionValue(ctx.initial, ctx.sizeIdx) : ''
      };
      const colorBtns = root.querySelectorAll('.look-card__swatch');
      const sizeBtns = root.querySelectorAll('.look-card__size');
      const colorValue = root.querySelector('.look-card__options--color .look-card__options-value');
      const sizeValue = root.querySelector('.look-card__options--size .look-card__options-value');
      const priceEl = root.querySelector('.look-card__price');
      const img = root.querySelector('.look-card__image');
      const links = root.querySelectorAll('a');
      const btn = root.querySelector('.look-card__submit');

      function findVariant() {
        const matches = ctx.pool.filter(function (v) {
          const colorOk = ctx.colorIdx === -1 || !state.color || optionValue(v, ctx.colorIdx).toLowerCase() === state.color;
          const sizeOk = ctx.sizeIdx === -1 || !state.size || optionValue(v, ctx.sizeIdx) === state.size;
          return colorOk && sizeOk;
        });
        return matches.find(function (v) { return v.available; }) || matches[0] || null;
      }

      function apply() {
        const v = findVariant() || ctx.initial;
        root.dataset.variantId = String(v.id);
        root.dataset.price = String(v.price || 0);
        root.dataset.compare = String(v.compare || 0);
        root.dataset.available = v.available ? '1' : '0';
        priceEl.innerHTML = priceHtml(v);
        const src = v.image || cfg.productImage;
        if (img && src) img.src = src;
        const href = cfg.urlBase + (cfg.urlBase.indexOf('?') === -1 ? '?' : '&') + 'variant=' + v.id;
        links.forEach(function (a) { a.href = href; });
        btn.disabled = !v.available;
        btn.textContent = v.available ? 'Add' : 'Sold out';
        updateFooter();
      }

      function updateSizeAvailability() {
        sizeBtns.forEach(function (b) {
          const size = b.getAttribute('data-val');
          const ok = ctx.pool.some(function (v) {
            if (!v.available) return false;
            if (ctx.colorIdx !== -1 && state.color && optionValue(v, ctx.colorIdx).toLowerCase() !== state.color) return false;
            return optionValue(v, ctx.sizeIdx) === size;
          });
          b.classList.toggle('_soldout', !ok);
          if (ok) {
            b.removeAttribute('aria-disabled');
          } else {
            b.setAttribute('aria-disabled', 'true');
          }
        });
      }

      function nearestAvailableSize(reference) {
        const arr = Array.prototype.slice.call(sizeBtns);
        if (!arr.length) return null;
        const refIdx = arr.findIndex(function (b) { return b.getAttribute('data-val') === reference; });
        if (refIdx === -1) {
          return arr.find(function (b) { return !b.classList.contains('_soldout'); }) || null;
        }
        for (let d = 1; d < arr.length; d++) {
          const left = arr[refIdx - d];
          const right = arr[refIdx + d];
          if (left && !left.classList.contains('_soldout')) return left;
          if (right && !right.classList.contains('_soldout')) return right;
        }
        return null;
      }

      function setColorUI(btnEl) {
        colorBtns.forEach(function (b) {
          const on = b === btnEl;
          b.classList.toggle('_selected', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        if (colorValue) colorValue.textContent = btnEl.getAttribute('data-color-label') || '';
      }

      function setSizeUI(btnEl) {
        sizeBtns.forEach(function (b) {
          const on = b === btnEl;
          b.classList.toggle('_selected', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        if (sizeValue) sizeValue.textContent = btnEl.getAttribute('data-val') || '';
      }

      // The options are divs, not buttons, so Enter and Space have to be wired up by hand.
      function bindOption(node, activate) {
        node.addEventListener('click', activate, { signal: signal });
        node.addEventListener('keydown', function (e) {
          if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
          e.preventDefault();
          activate(e);
        }, { signal: signal });
      }

      colorBtns.forEach(function (b) {
        bindOption(b, function (e) {
          e.stopPropagation();
          state.color = b.getAttribute('data-val') || '';
          setColorUI(b);
          const prevSize = state.size;
          updateSizeAvailability();
          if (ctx.sizeIdx !== -1 && sizeBtns.length) {
            const current = Array.prototype.find.call(sizeBtns, function (x) { return x.getAttribute('data-val') === state.size; });
            if (!current || current.classList.contains('_soldout')) {
              const next = nearestAvailableSize(prevSize);
              if (next) {
                state.size = next.getAttribute('data-val');
                setSizeUI(next);
              }
            }
          }
          apply();
          revealSelected(root);
        });
      });

      sizeBtns.forEach(function (b) {
        bindOption(b, function (e) {
          e.stopPropagation();
          if (b.classList.contains('_soldout')) return;
          state.size = b.getAttribute('data-val') || '';
          setSizeUI(b);
          apply();
        });
      });

      const initColorBtn = state.color && Array.prototype.find.call(colorBtns, function (b) { return b.getAttribute('data-val') === state.color; });
      if (initColorBtn) {
        setColorUI(initColorBtn);
      } else if (colorBtns.length) {
        state.color = colorBtns[0].getAttribute('data-val');
        setColorUI(colorBtns[0]);
      }
      updateSizeAvailability();
      const initSizeBtn = state.size && Array.prototype.find.call(sizeBtns, function (b) { return b.getAttribute('data-val') === state.size; });
      if (initSizeBtn) {
        setSizeUI(initSizeBtn);
      } else if (sizeBtns.length) {
        const next = nearestAvailableSize(state.size);
        if (next) {
          state.size = next.getAttribute('data-val');
          setSizeUI(next);
        }
      }
      apply();
    }

    function skeletonHtml(slot) {
      return '<div class="look-skeleton" data-look-slot="' + slot + '">' +
        '<div class="look-skeleton__media"></div>' +
        '<div class="look-skeleton__lines">' +
          '<div class="look-skeleton__line look-skeleton__line--title"></div>' +
          '<div class="look-skeleton__line look-skeleton__line--picker"></div>' +
          '<div class="look-skeleton__line look-skeleton__line--submit"></div>' +
        '</div>' +
      '</div>';
    }

    function updateFooter() {
      const footer = getFooter();
      if (!footer) return;
      const hasAddable = !!body.querySelector('.look-card[data-available="1"]');
      footer.hidden = !hasAddable;
    }

    function resetFooterError() {
      const footerError = getFooterError();
      if (footerError) {
        footerError.hidden = true;
        footerError.textContent = '';
      }
    }

    function showFooterError(message) {
      const footerError = getFooterError();
      if (footerError) {
        footerError.textContent = message;
        footerError.hidden = false;
      }
    }

    async function render() {
      renderToken += 1;
      const token = renderToken;

      destroySliders(body);
      body.innerHTML = '';
      const footer = getFooter();
      if (footer) footer.hidden = true;
      resetFooterError();

      const resolved = await resolveCurrentForOpen();
      if (token !== renderToken) return;
      if (!resolved || !resolved.info) {
        body.innerHTML = '<div class="shop-this-look-sidebar__empty">No products found for this look.</div>';
        return;
      }

      const ownId = String(resolved.id);
      const entries = lookFor(resolved.info).filter(function (entry) { return entry.id !== ownId; });
      const pdpCode = variantColor(resolved.info).trim().toLowerCase();
      const pdpColor = pdpCode ? { code: pdpCode, name: colorName(pdpCode).trim().toLowerCase() } : null;
      const pdpSize = currentSizeValue();

      body.innerHTML = '<div class="shop-this-look-sidebar__list"></div>';
      const list = body.querySelector('.shop-this-look-sidebar__list');
      const firstCard = buildCardEl(pdpCardConfig(resolved));
      if (firstCard) {
        list.appendChild(firstCard);
        initSliders(firstCard);
      }
      entries.forEach(function (_, i) { list.insertAdjacentHTML('beforeend', skeletonHtml('sk-' + i)); });
      updateFooter();

      const pending = entries.map(function (entry, i) {
        return fetchProductGql(entry.handle)
          .then(function (data) { return lookCardConfig(data, entry.id, pdpColor, pdpSize); })
          .catch(function () { return null; })
          .then(function (cfg) {
            if (token !== renderToken) return;
            const skeleton = list.querySelector('[data-look-slot="sk-' + i + '"]');
            if (!skeleton) return;
            const card = cfg ? buildCardEl(cfg) : null;
            if (card) {
              skeleton.replaceWith(card);
              initSliders(card);
            } else {
              skeleton.remove();
            }
            updateFooter();
          });
      });

      Promise.all(pending).then(function () { reportViewList(token); });
    }

    /* ----------------------------------------------------------------
     * GA4 analytics bridge. Publishes namespaced custom events that the
     * "Shop This Look -> GA4" custom pixel (Settings > Customer events)
     * forwards through the Measurement Protocol:
     *   liveclothing:stl_click       - click on the trigger button
     *   liveclothing:stl_view_list   - sidebar rendered, with the products shown
     *   liveclothing:stl_select_item - click through to a product page
     *   liveclothing:stl_add_to_cart - Add / Add all succeeded
     * Purchases are attributed in the pixel through the _stl_source
     * line-item property written by itemFromCard().
     * ---------------------------------------------------------------- */
    const LIST_ID = 'shop_this_look';
    const PROP_SOURCE = '_stl_source';

    function pub(name, payload) {
      try {
        if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
          Shopify.analytics.publish(name, payload || {});
        }
      } catch (e) { /* analytics unavailable - ignore */ }
    }

    function activeCurrency() {
      try { return (window.Shopify && Shopify.currency && Shopify.currency.active) || ''; } catch (e) { return ''; }
    }

    function pageContext() {
      return {
        page_location: window.location.href,
        page_title: document.title || '',
        product_handle: DATA.product.handle || '',
        product_title: DATA.product.title || ''
      };
    }

    function cardMeta(card) {
      const titleEl = card.querySelector('.look-card__title');
      return {
        item_id: String(card.dataset.variantId || ''),
        item_name: titleEl ? (titleEl.textContent || '').trim() : '',
        price: (parseInt(card.dataset.price, 10) || 0) / 100
      };
    }

    function cardItems(cards) {
      const items = [];
      cards.forEach(function (card, i) {
        const meta = cardMeta(card);
        if (!meta.item_id) return;
        items.push({ item_id: meta.item_id, item_name: meta.item_name, price: meta.price, quantity: 1, index: i });
      });
      return items;
    }

    function sumValue(items) {
      let total = 0;
      items.forEach(function (it) { total += (it.price || 0) * (it.quantity || 1); });
      return Math.round(total * 100) / 100;
    }

    function reportTriggerClick() {
      const resolved = resolveCurrentSync();
      pub('liveclothing:stl_click', Object.assign(pageContext(), {
        variant_id: resolved ? String(resolved.id) : '',
        look_count: resolved && resolved.info ? lookFor(resolved.info).length : 0
      }));
    }

    function reportViewList(token) {
      if (token !== renderToken) return;
      const items = cardItems(Array.prototype.slice.call(body.querySelectorAll('.look-card')));
      if (!items.length) return;
      pub('liveclothing:stl_view_list', Object.assign(pageContext(), {
        currency: activeCurrency(),
        item_count: items.length,
        items: items
      }));
    }

    function reportSelectItem(card) {
      const items = cardItems([card]);
      if (!items.length) return;
      pub('liveclothing:stl_select_item', Object.assign(pageContext(), {
        currency: activeCurrency(),
        items: items
      }));
    }

    function reportAdd(items, type) {
      if (!items.length) return;
      pub('liveclothing:stl_add_to_cart', Object.assign(pageContext(), {
        currency: activeCurrency(),
        add_type: type,
        item_count: items.length,
        value: sumValue(items),
        items: items
      }));
    }

    // ---- Cart ---- //

    function treeConfigured() {
      return !!(window.liquidVars && window.liquidVars.oneTreeProdID && window.liquidVars.oneTreeProdHandle);
    }

    async function addItemsToCart(items) {
      const res = await fetch(routeRoot() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      });
      let json = null;
      try { json = await res.json(); } catch (e) { /* noop */ }
      if (!res.ok) {
        const msg = json && (typeof json.description === 'string' ? json.description : json.message);
        throw new Error(msg || 'Unable to add to cart.');
      }
      try {
        if (window.Utilities && typeof Utilities.createCookie === 'function') Utilities.createCookie();
      } catch (e) { /* noop */ }
      return json;
    }

    function openCartFlyout() {
      try {
        if (treeConfigured() && typeof window.checkOneTree === 'function') {
          fetch(routeRoot() + 'cart.js', { headers: { 'Accept': 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (cart) { window.checkOneTree(cart, true); })
            .catch(function () {
              if (window.Utilities && Utilities.updateCart) Utilities.updateCart(null, true);
            });
        } else if (window.Utilities && Utilities.updateCart) {
          Utilities.updateCart(null, true);
        }
      } catch (e) { /* noop */ }
    }

    // Only the source is tagged: adding _stl_type as well would stop an 'Add' and
    // an 'Add all' of the same variant from merging into one cart line.
    function itemFromCard(card) {
      const price = parseInt(card.dataset.price, 10) || 0;
      const compare = parseInt(card.dataset.compare, 10) || 0;
      const props = {};
      props[PROP_SOURCE] = LIST_ID;
      if (compare > price) props['_compare-price'] = String(compare);
      return { id: parseInt(card.dataset.variantId, 10), quantity: 1, properties: props };
    }

    function startLoading(btn) {
      if (btn.classList.contains('_loading')) return false;
      btn.classList.add('_loading');
      btn.setAttribute('aria-busy', 'true');
      return true;
    }

    function stopLoading(btn) {
      btn.classList.remove('_loading');
      btn.removeAttribute('aria-busy');
    }

    function showCardError(card, message) {
      const err = card.querySelector('.look-card__error');
      if (!err) return;
      err.textContent = message;
      err.hidden = false;
      if (err._stlTimer) {
        clearTimeout(err._stlTimer);
        timers.delete(err._stlTimer);
      }
      err._stlTimer = later(function () { err.hidden = true; }, 5000);
    }

    async function addSingle(btn) {
      const card = btn.closest('.look-card');
      if (!card || adding || !startLoading(btn)) return;
      adding = true;
      try {
        const meta = cardMeta(card);
        await addItemsToCart([itemFromCard(card)]);
        reportAdd([{ item_id: meta.item_id, item_name: meta.item_name, price: meta.price, quantity: 1, index: 0 }], 'single');
        closeSidebar();
        openCartFlyout();
      } catch (err) {
        showCardError(card, err.message);
      } finally {
        adding = false;
        stopLoading(btn);
      }
    }

    async function addAll() {
      const addAllBtn = getAddAllBtn();
      if (adding || !addAllBtn) return;
      resetFooterError();

      const merged = {};
      const meta = {};
      body.querySelectorAll('.look-card[data-available="1"]').forEach(function (card) {
        const item = itemFromCard(card);
        if (!item.id) return;
        if (merged[item.id]) {
          merged[item.id].quantity += 1;
        } else {
          merged[item.id] = item;
          meta[item.id] = cardMeta(card);
        }
      });
      const items = Object.keys(merged).map(function (id) { return merged[id]; });

      if (!items.length) {
        showFooterError('All products in this look are sold out.');
        return;
      }

      if (!startLoading(addAllBtn)) return;
      adding = true;
      try {
        await addItemsToCart(items);
        reportAdd(items.map(function (it, i) {
          const m = meta[it.id] || {};
          return { item_id: String(it.id), item_name: m.item_name || '', price: m.price || 0, quantity: it.quantity || 1, index: i };
        }), 'all');
        closeSidebar();
        openCartFlyout();
      } catch (err) {
        showFooterError(err.message);
      } finally {
        adding = false;
        stopLoading(addAllBtn);
      }
    }

    // ---- Trigger button visibility ---- //

    function updateTriggerVisibility() {
      const wrap = document.querySelector('.shop-this-look-button-wrapper');
      if (!wrap) return;
      const resolved = resolveCurrentSync();
      const show = !!(resolved && resolved.info && lookFor(resolved.info).length);
      wrap.classList.toggle('_hidden', !show);
    }

    function queueVisibilityUpdate() {
      if (visibilityTimer) {
        clearTimeout(visibilityTimer);
        timers.delete(visibilityTimer);
      }
      visibilityTimer = later(updateTriggerVisibility, 300);
    }

    const MOBILE_MQ = window.matchMedia('(max-width: 767px)');
    const wrapper = document.querySelector('.shop-this-look-button-wrapper');
    const slider = wrapper && wrapper.closest('.product-main-slider');
    let slideObserver = null;

    function syncSlideGate() {
      if (!wrapper) return;
      if (slideObserver) { slideObserver.disconnect(); slideObserver = null; }

      const target = slider && slider.querySelector('.main-image-slide:not(.hidde-image-main-to-show)');
      if (!MOBILE_MQ.matches || !target || !('IntersectionObserver' in window)) {
        wrapper.classList.remove('_off-slide');
        return;
      }

      slideObserver = new IntersectionObserver(function (entries) {
        const entry = entries[entries.length - 1];
        const width = entry.boundingClientRect.width;
        const shown = width ? entry.intersectionRect.width / width : 1;
        wrapper.classList.toggle('_off-slide', shown < 0.5);
      }, { root: slider, threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1] });
      slideObserver.observe(target);
    }

    // ---- Open / close + focus management ---- //

    function focusableItems() {
      return Array.prototype.filter.call(sidebar.querySelectorAll(FOCUSABLE), function (node) {
        return node.offsetWidth > 0 || node.offsetHeight > 0 || node.getClientRects().length > 0;
      });
    }

    function isOpen() {
      return sidebar.classList.contains('open');
    }

    function openSidebar() {
      if (isOpen()) return;
      lastFocused = document.activeElement;
      sidebar.removeAttribute('inert');
      sidebar.removeAttribute('aria-hidden');
      sidebar.classList.add('open');
      if (overlay) overlay.classList.add('active');
      document.body.style.overflow = 'hidden';
      render();
      later(function () {
        const closeBtn = getCloseBtn();
        (closeBtn || sidebar).focus();
      }, 0);
    }

    function closeSidebar() {
      if (!isOpen()) return;
      sidebar.classList.remove('open');
      if (overlay) overlay.classList.remove('active');
      document.body.style.overflow = '';
      const target = lastFocused;
      lastFocused = null;
      if (target && typeof target.focus === 'function' && document.contains(target)) {
        target.focus();
      } else if (document.activeElement && sidebar.contains(document.activeElement)) {
        document.activeElement.blur();
      }
      sidebar.setAttribute('aria-hidden', 'true');
      sidebar.setAttribute('inert', '');
    }

    // ---- Init ---- //

    const lbObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType === 1 && /^LB-/.test(node.nodeName)) node.remove();
        });
      });
    });
    lbObserver.observe(body, { childList: true, subtree: true });
    observers.push(lbObserver);
    body.querySelectorAll('lb-upsell-widget, lb-embed, lb-addon').forEach(function (node) { node.remove(); });

    document.addEventListener('click', function (e) {
      if (!e.target || !e.target.closest) return;
      if (e.target.closest('.shop-this-look-button')) {
        reportTriggerClick();
        openSidebar();
        return;
      }
      if (sidebar.contains(e.target)) {
        const productLink = e.target.closest('.look-card__title-link, .look-card__media');
        if (productLink) {
          const linkedCard = productLink.closest('.look-card');
          if (linkedCard) reportSelectItem(linkedCard);
        }
        const addBtn = e.target.closest('.look-card__submit');
        if (addBtn && !addBtn.disabled) {
          addSingle(addBtn);
          return;
        }
        if (e.target.closest('#ShopThisLookAddAll')) {
          addAll();
          return;
        }
      }
      if (e.target.closest('.option-color') || e.target.closest('.product-variants .selector-options > div')) {
        queueVisibilityUpdate();
        later(syncSlideGate, 300);
      }
    }, { signal: signal });

    document.addEventListener('keydown', function (e) {
      if (!isOpen()) return;
      if (e.key === 'Escape' || e.keyCode === 27) {
        e.preventDefault();
        closeSidebar();
      }
    }, { signal: signal });

    sidebar.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab' || !isOpen()) return;
      const items = focusableItems();
      if (!items.length) {
        e.preventDefault();
        sidebar.focus();
        return;
      }
      const first = items[0];
      const last = items[items.length - 1];
      const current = document.activeElement;
      if (e.shiftKey && (current === first || current === sidebar || !sidebar.contains(current))) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && current === last) {
        e.preventDefault();
        first.focus();
      }
    }, { signal: signal });

    const closeBtn = getCloseBtn();
    if (closeBtn) closeBtn.addEventListener('click', closeSidebar, { signal: signal });
    if (overlay) overlay.addEventListener('click', closeSidebar, { signal: signal });

    const notifyEl = document.querySelector('.custom-notify-form[data-notify-variant]');
    if (notifyEl) {
      const variantObserver = new MutationObserver(queueVisibilityUpdate);
      variantObserver.observe(notifyEl, { attributes: true, attributeFilter: ['data-notify-variant'] });
      observers.push(variantObserver);
    }

    if (DATA.capped) {
      ensurePdpGql().then(updateTriggerVisibility).catch(function () { /* noop */ });
    }

    const galleryEl = document.getElementById('swiper-main-image-content');
    if (galleryEl && 'MutationObserver' in window) {
      const galleryObserver = new MutationObserver(syncSlideGate);
      galleryObserver.observe(galleryEl, { childList: true });
      observers.push(galleryObserver);
    }
    if (MOBILE_MQ.addEventListener) {
      MOBILE_MQ.addEventListener('change', syncSlideGate, { signal: signal });
    }

    updateTriggerVisibility();
    syncSlideGate();
    later(updateTriggerVisibility, 1000);
    later(syncSlideGate, 1000);

    function destroy() {
      if (isOpen()) closeSidebar();
      controller.abort();
      destroySliders(body);
      if (slideObserver) { slideObserver.disconnect(); slideObserver = null; }
      observers.forEach(function (o) { o.disconnect(); });
      observers.length = 0;
      timers.forEach(function (id) { clearTimeout(id); });
      timers.clear();
    }

    return { destroy: destroy, root: sidebar };
  }

  function boot() {
    if (window.__shopThisLook && typeof window.__shopThisLook.destroy === 'function') {
      window.__shopThisLook.destroy();
    }
    window.__shopThisLook = createInstance();
  }

  boot();

  // The theme editor swaps section markup without re-running this file, so re-bind against the fresh DOM.
  if (!window.__shopThisLookSectionBound) {
    window.__shopThisLookSectionBound = true;

    document.addEventListener('shopify:section:unload', function () {
      const instance = window.__shopThisLook;
      if (instance && instance.root && !document.contains(instance.root)) {
        instance.destroy();
        window.__shopThisLook = null;
      }
    });

    document.addEventListener('shopify:section:load', function () {
      const instance = window.__shopThisLook;
      const fresh = document.getElementById('ShopThisLookSidebar');
      if (instance && instance.root === fresh) return;
      boot();
    });
  }
})();
